import React from "react";
import "../../assets/css/fields-group.css";

type FieldsGroupProps = {
  children?: React.ReactNode;
  visible?: boolean;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  onFormFieldInteraction?: (event: React.FocusEvent<HTMLElement>) => void;
  onFormFieldChange?: (event: React.ChangeEvent<HTMLFormElement>) => void;
};

export function FieldsGroup(props: FieldsGroupProps) {
  const {
    children,
    visible = true,
    className = "",
    disabled = false,
    loading = false,
    onFormFieldInteraction,
    onFormFieldChange
  } = props;

  const style = visible ? {} : { display: "none" };
  const disabledClass = disabled ? "disabled" : "";
  const loadingClass = loading === true ? "loading" : "";

  const handleFormFocus = (event: React.FocusEvent<HTMLElement>) => {
    if (event.target instanceof HTMLInputElement && onFormFieldInteraction) {
      onFormFieldInteraction(event);
    }
  };

  const handleFormChange = (event: React.ChangeEvent<HTMLFormElement>) => {
    if (onFormFieldChange) {
      onFormFieldChange(event);
    }
  };

  return (
    <form
      className={`fieldsgroup ${className} ${disabledClass} ${loadingClass}`}
      style={style}
      onFocus={handleFormFocus}
      onChange={handleFormChange}
      autoComplete="on">
      {children}
    </form>
  );
}

export default FieldsGroup;
